import { formatter, request } from '@/utils/request';

export namespace SA {
  export const Path = {
    QueryForMy: '/reportapi/sa/queryForMy',
    QuerySa: '/reportapi/sa/query',
    QueryAll: '/reportapi/sa/queryAll',
    Export: '/reportapi/sa/export',
    queryForActivity: '/reportapi/report/queryForActivity',
    queryForPdActivity: '/reportapi/report/queryForPdActivity',
    ExportFileForActivity: '/reportapi/report/exportFileForActivity',
    ExportFileForPdActivity: '/reportapi/report/exportFileForPdActivity',
    exportForActivity: '/reportapi/report/exportForActivity',
    exportForPdActivity: '/reportapi/report/exportForPdActivity',
    exportPdSaDetails: '/reportapi/sa/exportPdSaDetails',
  };

  export async function queryForMy(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        sortdatafield: 'createdDate',
        sortorder: 'DESC',
        ...body,
      },
    };
    return request<API.QueryResult<any>>(SA.Path.QueryForMy, formatter(options));
  }

  export async function querySa(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any>>(SA.Path.QuerySa, formatter(options));
  }

  export async function queryAll(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any>>(SA.Path.QueryAll, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.Export, formatter(options));
  }

  export async function queryForActivity(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any>>(Path.queryForActivity, formatter(options));
  }

  export async function queryForPdActivity(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<any>>(Path.queryForPdActivity, formatter(options));
  }

  export async function exportForActivity(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.exportForActivity, formatter(options));
  }

  export async function exportForPdActivity(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.exportForPdActivity, formatter(options));
  }

  export async function exportPdSaDetails(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.PdSaDetailExport[]>>(
      Path.exportPdSaDetails,
      formatter(options),
    );
  }
}
